// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"222":"0d973452","421":"12121cbb"}[chunkId] + ".chunk.css");